export default __webpack_public_path__ + "static/media/people11.779b232a.jpeg";